import React, {useState} from 'react'
import styled from 'styled-components'
import GlobalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'
import { Notification } from '../../../common/components/Notification/Notification'
import { Recipient } from 'plugin-reports-maker/webapp/js/common/types/form'
import { ModalRecipientsImportSummary } from './ModalRecipientsImportSummary'
import {downloadTemplate} from './helper/downloadCsvTemplate'
import handleNewFile from './helper/recipientImporterHandleNewFile'
import {CsvToRecipientData} from './helper/types'

export interface FileUploaderToRecipientProps {
    currentSavedRecipients: Recipient[]
    onFileChange: (recipientList: Recipient[]) => void
}

export const FileUploaderToRecipient = ({ onFileChange, currentSavedRecipients }: FileUploaderToRecipientProps): JSX.Element => {
    const hiddenFileInput = React.useRef(null)

    const [showSummaryModal, setShowSummaryModal] = useState<boolean>(false)
    const [importedRecipients, setImportedRecipients] = useState<CsvToRecipientData[]>([])

    return (
        <StyledUploaderButton>
            <div className='uploadButton'>
                <input
                    ref={hiddenFileInput}
                    onChange={(event) => {
                        handleNewFile(event)
                            .then(convertedRecipients => {
                                setImportedRecipients(convertedRecipients)
                                setShowSummaryModal(true)
                            })
                            .catch(err => {
                                GlobalNotification.error(
                                    <Notification title={i18n("The spreadsheet can't be uploaded due to incorrect formatting: ")}>{err.message}</Notification>,
                                    20
                                )
                                console.error(err);
                            }).finally(() => {
                                if(hiddenFileInput && hiddenFileInput.current)
                                    hiddenFileInput.current.value = null
                            })
                    }}
                    type="file"
                    style={{ display: "none" }}
                />
                <button 
                    className="uploadButton--importButton text-left"
                    onClick={() => {
                        hiddenFileInput.current.click()
                    }}>
                    <i className="far fa-file-import" />
                    <span>{i18n('Import Groups')}</span>
                </button>
                <br/>
                <div className='uploadButton--templateDownload'>
                    <span>You can also import groups by using this <a onClick={() => downloadTemplate()}>spreadsheet template.</a></span>
                </div>
                <ModalRecipientsImportSummary
                    showingSummaryModal={showSummaryModal}
                    currentSavedRecipients={
                        currentSavedRecipients.map(r => {
                            return {
                                errors: [],
                                recipient: r
                            } as CsvToRecipientData
                        })
                    }
                    importedRecipients={importedRecipients}
                    onClose={(isCancel) => setShowSummaryModal(false)}
                    onSave={(newRecipients) => {
                        onFileChange(newRecipients)
                    }}
                />
            </div>
        </StyledUploaderButton>
    )
}

const StyledUploaderButton = styled.div`
    .uploadButton {
        &--importButton {
            border: 0px;
            width: 100%;
            background: ${({ theme }) => theme['gray-0']};
            padding: 4px 10px;
            :hover {
                background: ${({ theme }) => theme['gray-300']};
            }
            i {
                margin-right: 8px;
            }
        }
        &--templateDownload {
            font-size: 12px;
            padding: 5px;
        }
    }
`;
